import { Action, isActionOfType } from '../types';
import initialState from './initialState';
import type { AuthStore } from './types';
import {
  addRedirectParam,
  loginSuccess,
  logoutSuccess,
  resetRedirectParam,
} from './actions';
import type { AuthActionTypes } from './actions';

const reducer = (
  state: AuthStore = initialState,
  action: Action<AuthActionTypes>
): AuthStore => {
  if (isActionOfType(action, loginSuccess)) {
    return {
      ...state,
      isLoggedIn: true,
    };
  }

  if (isActionOfType(action, logoutSuccess)) {
    return {
      isLoggedIn: false,
      redirect: null,
    };
  }

  if (isActionOfType(action, addRedirectParam)) {
    const { to, hash, actionRequired, params } = action.payload;

    return {
      ...state,
      redirect: { to, hash, actionRequired, params },
    };
  }

  if (isActionOfType(action, resetRedirectParam)) {
    return {
      ...state,
      redirect: null,
    };
  }

  return state;
};

export default reducer;
